import React, { useContext } from 'react'

import BtnPrimary from '../../components/Buttons/Primary'
import FormGroup from '../../components/Forms/Group'
import InputText from '../../components/Fields/InputText'
import Window from '../../components/Divs/Window'

import logout from '../actions/logout'

import { Session } from "../provider";

const Component = (props) => {
  
  const { state, dispatch } = useContext(Session);
 	const { data } = state;

  const btnSaveProps = {
  	className: "pri",
  	onClick: () => logout()(dispatch),
  	title: "SALVAR"
  }

  const btnLogoutProps = {
  	className: "sec",
  	onClick: () => logout()(dispatch),
  	title: "LOGOUT"
  }

  const initFormState = {
  	message: "",
  	submited: false,
  	success: false
  }
  
  const inputFirstname = {
  	className: "pri",
    defaultValue: data.firstname,
    disabled: true,
  	label: "Nome",
    // onChange: handleField("email"),
    // onKeyPress: handleKeyPress(),
  	type: "text"
  }
  
  const inputEmailProps = {
  	className: "pri",
    defaultValue: data.email,
    disabled: true,
  	label: "E-mail",
    // onChange: handleField("email"),
    // onKeyPress: handleKeyPress(),
  	type: "text"
  }
  
  return (
		<Window>
			<FormGroup {...initFormState}>
				<InputText {...inputFirstname} />
				<InputText {...inputEmailProps} />
				<BtnPrimary {...btnLogoutProps} />
			</FormGroup>
		</Window>			
  )
}
export default Component
